export default class MessageInfoService {
  constructor() {
  }

  getExplanation(step, params) {
    switch (step) {
      case 'city':
        return this.getCityMessage()
      case 'study':
        return this.getStudyConfigurationMessage()
      case 'dependent-pj':
        return this.getDependentsPJ()
      case 'dependent-pf':
        return this.getDependentsMessagePF()
      case 'age-pf':
        return this.getAgeMessagePF()
      case 'confort':
        return this.getConfort()
      case 'copay':
        return this.getCopay(params)
      case 'nao-disponivel':
        return this.getNaoDisponivel();
      case 'price':
        return this.getPrice(params)
      case 'pricePJ':
        return this.getPricePJ(params)
      case 'remissao-quote':
        return this.getRemissaoQuote()
    }
    return '';
  }

  getPricePJ(preco) {
    return `Encontramos alternativas que atendem o perfil de sua empresa.<br />Custos a partir de ${preco} <br />Agora, olhe com calma e escolha até 5 opções de planos por operadora, para que possamos enviar uma cotação detalhada em seu email. A cotação apresentará, também, informações adicionais sobre coberturas, rede referenciada, reembolso e regras de contratação.`;
  }

  getPrice(preco) {
    return `Encontramos alternativas que atendem o seu perfil.<br />Planos a partir de ${preco} <br />Agora, olhe com calma e escolha até 5 opções de planos por operadora, para que possamos enviar uma cotação detalhada em seu email. A cotação apresentará, também, informações adicionais sobre coberturas, rede referenciada, reembolso e regras de contratação.`;
  }

  getCopay(personType) {
    if (personType === "PJ") {
      return `Você pode escolher planos Com ou Sem Coparticipação. A Coparticipação é uma taxa cobrada sobre o valor dos procedimentos que o usuário realizar. Uma forma para equilibrar o orçamento, com preços mais acessíveis. A Coparticipação, também, possibilita a diminuição da sinistralidade e o incentivo ao uso consciente do plano. Escolha abaixo a melhor opção que atenda ao seu perfil. Se você ainda não está certo de sua escolha, selecione as duas opções.`;
    }
    else {
      return `Você pode escolher planos Com ou Sem Coparticipação. A Coparticipação é uma taxa cobrada sobre o valor dos procedimentos que o usuário realizar. Uma forma para equilibrar o orçamento, com preços mais acessíveis. A Coparticipação, também, possibilita o incentivo ao uso consciente do plano. Escolha abaixo a melhor opção que atenda ao seu perfil. Se você ainda não está certo de sua escolha, selecione as duas opções.`;
    }
  }

  getConfort() {
    return `O conforto de um plano é o tipo de acomodação que você terá disponível no caso de uma internação. Planos com conforto Enfermaria, oferecem acomodação coletiva e podem ter preços mais acessíveis. Planos com conforto Apartamento, oferecem acomodação individual e privativa. Escolha abaixo, a melhor opção que atenda ao seu perfil. Se você ainda não está certo de sua escolha, selecione as duas opções.`;
  }

  getCityMessage() {
    return `Com o cuidado de oferecer sempre o melhor, procuramos para você ou sua empresa as melhores opções de produtos de Saúde. Por favor, informe a cidade que você gostaria de ter a maior cobertura de profissionais e serviços de saúde para selecionarmos os planos mais adequados para você.`;
  }

  getStudyConfigurationMessage() {
    return `Se você fizer parte de alguma associação ou projeto da lista abaixo, escolha a opção que melhor encaixe em seu perfil. Buscaremos as melhores alternativas de produtos e preços, sempre pensando nas melhores alternativas para você ou sua empresa.`;
  }

  getDependentsMessagePF() {
    return `Além de você, para quantas pessoas de sua família (Cônjuge e/ou Filhos) você deseja contratar o plano de Saúde?`;
  }

  getAgeMessagePF() {
    return `Agora preciso que você me informe a sua idade na linha Titular e a idade dos membros de sua família (Cônjuge e/ou Filhos) nas linhas dos dependentes. <br/>Vamos lá! Estamos quase terminando!`;
  }

  getDependentsPJ() {
    return `Por favor, informe a quantidade de Titulares e Dependentes (Cônjuge e/ou Filhos) de sua empresa, os quais você gostaria de incluir no plano de Saúde, de acordo com cada faixa etária abaixo.`
  }

  getNaoDisponivel() {
    return `Por favor entre em contato com a área de Adesão Sincare através do telefone (11) 4040-9310.`;
  }

  getRemissaoQuote() {
    return 'Trouxemos todos os dados da sua cotação e agora você pode alterar qualquer dado para reemissão.'
  }

}
